import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";

import { useQuery } from "@tanstack/react-query";
import { LogTrace } from "components/AppInsights/TelemetryService";

export function useIgnoreClaimApi(parameters, onSuccessCallback = null) {
  const { oktaAuth } = useOktaAuth();

  const dataKey = "useIgnoreClaimApiResult";

  async function GetApiResult() {
    if (Object.keys(parameters).length === 0) {
      return null;
    }
    else {
      const accessToken = oktaAuth.getAccessToken();

      var apiEndpoint = "api/AgingDetails/IgnoreClaims";

      //NOTE: Setting initial log level to "warning", I just want to make sure the traces are coming up
      LogTrace(
        "Claims are ignored: " + JSON.stringify(parameters),
        {
          componentName: "useIgnoreClaimApi",
          apiEndpoint: apiEndpoint
        },
        1);

      var result = await axios
        .get(apiEndpoint, {
          params: parameters,
          headers: { Authorization: `Bearer ${accessToken}` },
        })
        .then((response) => {
          if (onSuccessCallback) {
            onSuccessCallback(response);
          }
          return response.data;
        })
        .catch((error) => {
          throw new Error(error);
        });

      return result;
    }

  }

  return useQuery({
    queryKey: [dataKey, parameters],
    queryFn: async () => await GetApiResult(),
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
